import { FEATURES, BIZ } from "../data/content";
import PricingGrid from "../components/PricingGrid";
import Faq from "../components/Faq";
import CtaBanner from "../components/CtaBanner";

export default function FeaturesPage({ nav }) {
  return (
    <div className="page">

      {/* ── BANNER ── */}
      <div className="feat-banner">
        <div style={{ position: "relative", zIndex: 2, maxWidth: 560 }}>
          <div className="eyebrow">Features</div>
          <h1 style={{ fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 900, lineHeight: 1.08, marginBottom: 14, fontFamily: "'Fraunces',serif" }}>
            20+ features, <em>one app</em>
          </h1>
          <p style={{ color: "rgba(255,255,255,.5)", fontSize: "1rem", lineHeight: 1.75 }}>
            Everything your restaurant operation needs — from billing to kitchen display to
            loyalty programmes — all verified features available in Ooon today.
          </p>
        </div>
      </div>

      {/* ── ALL FEATURES ── */}
      <div className="feat-grid">
        {FEATURES.map((f, i) => (
          <div className="fc" key={i}>
            <div className="fc-num">{String(i + 1).padStart(2, "0")}</div>
            <div className="fc-icon">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </div>

      {/* ── BUSINESS TYPES ── */}
      <div className="biz-band">
        <div className="eyebrow">Compatible With</div>
        <h2 className="sec-title" style={{ fontSize: "1.7rem" }}>Works for <em>every</em> format</h2>
        <div className="biz-row">
          {BIZ.map((b, i) => <div className="biz-chip" key={i}>{b.icon} {b.label}</div>)}
        </div>
      </div>

      {/* ── PRICING ── */}
      <div className="price-band">
        <div style={{ position: "relative", zIndex: 2, textAlign: "center", maxWidth: 500, margin: "0 auto" }}>
          <div className="eyebrow">Pricing</div>
          <h2 className="sec-title">Simple, <em style={{ color: "var(--lime2)" }}>honest</em> pricing</h2>
          <p className="sec-sub" style={{ margin: "0 auto" }}>
            Start free for 15 days. No credit card needed. Scale when you're ready.
          </p>
        </div>
        <PricingGrid />
      </div>

      {/* ── FAQ ── */}
      <Faq />

      <div style={{ height: 80 }} />
      <CtaBanner
        title="Have more questions?"
        subtitle="Our team is happy to walk you through Ooon live."
        btnText="Talk to Us →"
        onClick={() => nav("contact")}
      />
    </div>
  );
}
